export class Permission {
    Id: number;
    Title: string;
    IsActive?: boolean;
}